import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-garage-developer-guide/ibm-garage-developer-guide/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import Globals from 'gatsby-theme-carbon/src/templates/Globals';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Learning tasks for developers to understand the fundamentals of cloud-native development with `}<Globals name="ocp" mdxType="Globals" />{` and `}<Globals name="kube" mdxType="Globals" /></p>
    </PageDescription>
    <h2>{`Self-paced Agenda`}</h2>
    <p>{`This self-paced agenda is part of the `}<a parentName="p" {...{
        "href": "https://cloudnative101.dev"
      }}>{`Cloud-Native Bootcamp`}</a></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Topic`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type of Activity`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Duration`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://cloudnative101.dev/lectures/containers/"
            }}>{`Containers`}</a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Presentation`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1 Hour`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://cloudnative101.dev/lectures/containers/#activities"
            }}>{`Container Activities`}</a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Activity`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`30 mins`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://cloudnative101.dev/concepts/kubernetes/"
            }}>{`Kubernetes`}</a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Presentation`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`6 Hours`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://cloudnative101.dev/lectures/kube-overview/#activities"
            }}>{`Kubernetes Activities`}</a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Activity`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`4 Hours`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://cloudnative101.dev/lectures/continuous-integration/"
            }}>{`Continuous Integration`}</a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Presentation`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1 Hour`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://cloudnative101.dev/lectures/continuous-integration/#activities"
            }}>{`Continuous Integration Lab`}</a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Activity`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1 Hour`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://cloudnative101.dev/lectures/continuous-deployment/"
            }}>{`Continuous Deployment`}</a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Presentation`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1 Hour`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://cloudnative101.dev/lectures/continuous-deployment/#activities"
            }}>{`Continuous Deployment Lab`}</a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Activity`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1 Hour`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://cloudnative101.dev/projects/project-cicd/"
            }}>{`Project Work`}</a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Activity`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`2 Hours`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      